import { FunctionComponent } from 'react'
import { DialogWrapper } from '../../display-elements-components/dialog-wrapper'
import { EmissionEvidencePanel, IEvidenceDocumentsApi } from '../../emissons-components/overview/emission-evidence-panel'
import ManagementSystemCertificationService from '../../../../shared/services/management-system-certification/management-system-certification.service'
import { IManagementSystemCertification } from '../../../../shared/services/management-system-certification/management-system-certification.model'

const ACCEPTED_CERTIFICATE_TYPES = 'application/pdf,image/png,image/jpeg'

/** The certificate document(s) for one certificate, through the shared evidence panel. */
export const CertificationDocumentsDialog: FunctionComponent<{
  open: boolean,
  onClose: () => void,
  certification: IManagementSystemCertification | null,
  canEdit: boolean,
}> = ({ open, onClose, certification, canEdit }) => {
  const service = new ManagementSystemCertificationService()
  const id = certification?.id || ''
  const documentsApi: IEvidenceDocumentsApi = {
    list: () => service.getDocuments(id),
    upload: (files) => service.uploadDocuments(id, files),
    remove: (resourceId) => service.removeDocument(id, resourceId),
  }

  return (
    <DialogWrapper
      open={open}
      onClose={onClose}
      title={certification ? `${certification.derived.label || 'Certificate'} documents` : 'Certificate documents'}
      cancelHandler={onClose}
      submitHandler={onClose}
      isSubmitting={false}
      hideCancelButton
      submitButtonText='Done'
    >
      {certification && (
        <EmissionEvidencePanel
          canEdit={canEdit}
          documentsApi={documentsApi}
          resourceKey={certification.id}
          acceptedFileTypes={ACCEPTED_CERTIFICATE_TYPES}
          previewable
          copy={{
            intro: 'The certificate itself, as a PDF or image. It is listed on the cover sheet of the ISO 14001 evidence workbook.',
            empty: 'No document is attached to this certificate.',
            removeMessage: (filename) => `Are you sure you want to remove "${filename}" from this certificate? The stored file is kept for audit history.`,
            uploadLabel: 'Upload certificate',
            uploadedMessage: 'Certificate uploaded',
            removedMessage: 'Document removed',
          }}
        />
      )}
    </DialogWrapper>
  )
}
